import React, { memo } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { alpha } from "@mui/system/colorManipulator";
import { sidebarMenuExpanded, useStore } from "../../helpers";
import { ReactRouterLink } from "../Link";
const sxStyles = ({ spacing, transitions, palette }) => ({
    listItem: {
        padding: 0,
        marginTop: "4px",
        marginBottom: "6px",
        whiteSpace: "nowrap",
    },
    listItemButton: {
        borderTopLeftRadius: spacing(3),
        borderBottomLeftRadius: spacing(3),
        padding: spacing(0.75, 1.25),
        "&:hover": {
            // TODO: get color from palette
            backgroundColor: "#25549D",
        },
        "& .MuiTouchRipple-root": {
            left: "2px",
        },
    },
    active: {
        position: "relative",
        "&:before": {
            position: "absolute",
            top: 0,
            bottom: 0,
            left: "2px",
            zIndex: -1,
            width: spacing(6 - 4 * 0.25),
            borderRadius: spacing(3),
            backgroundColor: alpha(palette.primary.contrastText, palette.action.activatedOpacity),
            transition: transitions.create(["width", "border-radius", "background-color"], {
                duration: transitions.duration.enteringScreen,
                delay: transitions.duration.complex,
            }),
            content: '""',
        },
    },
    expanded: {
        position: "relative",
        "&:before": {
            position: "absolute",
            top: 0,
            bottom: 0,
            left: "2px",
            zIndex: -1,
            width: `${spacing(27 - 0.25)} !important`,
            borderTopLeftRadius: spacing(3),
            borderBottomLeftRadius: spacing(3),
            backgroundColor: alpha(palette.primary.contrastText, palette.action.activatedOpacity),
            transition: transitions.create(["width", "border-radius", "background-color"], {
                duration: transitions.duration.leavingScreen,
                delay: transitions.duration.shortest,
            }),
            content: '""',
        },
    },
    hovered: {
        "&:before": {
            content: '""',
        },
    },
    labelWithIcon: {
        marginLeft: "12px",
        " > span": {
            maxWidth: "158px",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
    },
    activeTextRoot: {
        fontWeight: 700,
    },
});
const SidebarItem = ({ icon, label, to, selected, isParent = false, ListItemTextProps, ListItemButtonProps, linkComponent: LinkComponent = ReactRouterLink, ...ListItemProps }) => {
    const isExpanded = useStore(sidebarMenuExpanded);
    return (React.createElement(ListItem, { component: "div", ...ListItemProps, sx: (theme) => sxStyles(theme).listItem, className: ListItemProps?.className },
        React.createElement(ListItemButton, { component: LinkComponent, sx: (theme) => ({
                ...sxStyles(theme).listItemButton,
                ...(selected && !isExpanded && sxStyles(theme).active),
                ...(isExpanded && selected && sxStyles(theme).expanded),
                ...(isParent && isExpanded && sxStyles(theme).hovered),
            }), selected: selected, to: to, ...ListItemButtonProps },
            icon,
            React.createElement(ListItemText, { ...ListItemTextProps, primary: label, disableTypography: isParent, className: ListItemTextProps?.className, sx: (theme) => ({
                    ...(!!icon && sxStyles(theme).labelWithIcon),
                    ...(isParent && sxStyles(theme).activeTextRoot),
                }) }))));
};
export default memo(SidebarItem);
//# sourceMappingURL=SidebarItem.js.map